import React from "react";
import { Box, Typography, Grid, Card, CardMedia } from "@mui/material";
import Tech from "../../images/D6.png";
import Dev from "../../images/D7.png";
import AI from "../../images/D8.png";
import Robotics from "../../images/D5.png";

const areas = [
  { title: "Technology", image: Tech },
  { title: "Development", image: Dev },
  { title: "Artificial Intelligence", image: AI },
  { title: "Robotics", image: Robotics },
];

export default function FocusAreas() {
  return (
    <Box sx={{ width: "100%", background: "#fff", py: 8 }}>
      <Box sx={{ width: "90%", mx: "auto" }}>
        <Typography variant="h4" fontWeight="800" textAlign="center" mb={6} sx={{ color: "#0f172a" }}>
          Focus Areas
        </Typography>
        
        <Grid container spacing={3}>
          {areas.map((area, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card
                sx={{
                  position: "relative",
                  overflow: "hidden",
                  borderRadius: 4,
                  height: "450px",
                  cursor: "pointer",
                  backgroundColor: "#000",
                  // --- OUTLINE EFFECT ---
                  border: "2px solid transparent",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  
                  "&:hover": {
                    transform: "translateY(-12px)", // Lift effect
                    borderColor: "#8257E6", // Outline color
                    boxShadow: "0 20px 40px rgba(130, 87, 230, 0.3)", // Glow effect
                    "& .overlay": { opacity: 1 },
                    "& .card-image": { transform: "scale(1.1)" }, // Zoom effect
                    "& .title": { opacity: 1, transform: "translateY(0)" },
                  },
                }}
              >
                {/* Image with Zoom Transition */}
                <CardMedia
                  component="img"
                  src={area.image}
                  alt={area.title}
                  className="card-image"
                  sx={{ 
                    width: "100%", 
                    height: "100%", 
                    objectFit: "cover",
                    transition: "transform 0.6s ease-in-out" 
                  }}
                />

                {/* Animated Overlay */}
                <Box
                  className="overlay"
                  sx={{
                    position: "absolute",
                    inset: 0,
                    // Gradient overlay looks more professional than flat color
                    background: "linear-gradient(to top, rgba(130, 87, 230, 0.8), rgba(15, 23, 42, 0.4))",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    opacity: 0,
                    transition: "opacity 0.4s ease-in-out",
                  }}
                >
                  <Typography
                    variant="h3"
                    className="title"
                    sx={{
                      color: "white",
                      fontWeight: "900",
                      textAlign: "center",
                      textTransform: "uppercase",
                      letterSpacing: "4px",
                      transform: "translateY(40px)",
                      transition: "all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                      opacity: 0,
                      writingMode: "vertical-lr",
                      textOrientation: "mixed",
                      textShadow: "0 4px 10px rgba(0,0,0,0.3)"
                    }}
                  >
                    {area.title}
                  </Typography>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}